export default "__VITE_ASSET__B884h3dw__"